import React, { useCallback, useEffect } from "react";
import { FOCUS_EVENT_TYPE } from "@/models/eventType";
import { RootState, RootDispatch } from "../../models/configure_store";
import { useSelector, useDispatch } from "react-redux";
import { getButton } from "@/utils/utils";
function CollectData() {
  const init_time = useSelector((state: RootState) => state.captcha.init_time);
  const dispatch = useDispatch<RootDispatch>();
  const handleWindowFocus = (event: FocusEvent) => {
    const time = Date.now() - init_time;
    dispatch.captcha.trackFocus({
      type: FOCUS_EVENT_TYPE.FOCUS,
      target: document?.activeElement?.tagName,
      time,
    });
  };

  const handleWindowBlur = (event: FocusEvent) => {
    const time = Date.now() - init_time;
    dispatch.captcha.trackFocus({
      type: FOCUS_EVENT_TYPE.UNFOCUS,
      target: document?.activeElement?.tagName,
      time,
    });
  };
  const handleClick = (event: MouseEvent) => {
    const time = Date.now() - init_time;
    const target = event?.target as HTMLElement;
    const x = Number(event?.clientX?.toFixed(0));
    const y = Number(event?.clientY?.toFixed(0));
    dispatch.captcha.trackClick({
      button: getButton(event?.button),
      x,
      y,
      time,
      target: target?.tagName,
    });
  };
  const handleMouseUp = (event: MouseEvent) => {
    const time = Date.now() - init_time;
    const target = event?.target as HTMLElement;
    const x = Number(event?.clientX?.toFixed(0));
    const y = Number(event?.clientY?.toFixed(0));
    dispatch.captcha.trackMouseUp({
      button: getButton(event?.button),
      x,
      y,
      time,
      target: target?.tagName,
    });
  };

  const handleTouchStart = (event: TouchEvent) => {
    const time = Date.now() - init_time;
    const target = event?.target as HTMLElement;
    Array.from(event.changedTouches)
      .map((touch: any) => {
        const x = Number(touch?.clientX?.toFixed(0));
        const y = Number(touch?.clientY?.toFixed(0));
        return {
          id: touch?.identifier,
          x,
          y,
          time,
          target: target?.tagName,
        };
      })
      .forEach((item: any) => {
        dispatch.captcha.trackTouchStart(item);
      });
  };

  const handleTouchEnd = (event: TouchEvent) => {
    const time = Date.now() - init_time;
    const target = event?.target as HTMLElement;
    Array.from(event.changedTouches)
      .map((touch: any) => {
        const x = Number(touch?.clientX?.toFixed(0));
        const y = Number(touch?.clientY?.toFixed(0));
        return {
          id: touch?.identifier,
          x,
          y,
          time,
          target: target?.tagName,
        };
      })
      .forEach((item: any) => {
        dispatch.captcha.trackTouchEnd(item);
      });
  };

  const handleMouseMove = useCallback((event: MouseEvent) => {
    const time = Date.now() - init_time;
    const x = Number(event?.clientX?.toFixed(0));
    const y = Number(event?.clientY?.toFixed(0));
    const target = event?.target as HTMLElement;
    dispatch.captcha.trackMouseMove({ x, y, time, target: target?.tagName });
  }, []);
  const handleDevice = useCallback((event: DeviceOrientationEvent) => {
    const time = Date.now() - init_time;
    const alpha = Number(event?.alpha?.toFixed(0));
    const beta = Number(event?.beta?.toFixed(0));
    const gamma = Number(event?.gamma?.toFixed(0));
    dispatch.captcha.trackDevice({ alpha, beta, gamma, time });
  }, []);

  const handleTouchMove = useCallback((event: TouchEvent) => {
    const time = Date.now() - init_time;
    const target = event?.target as HTMLElement;
    Array.from(event.changedTouches)
      .map((touch: any) => {
        const x = Number(touch?.clientX?.toFixed(0));
        const y = Number(touch?.clientY?.toFixed(0));
        return {
          x,
          y,
          time,
          target: target?.tagName,
        };
      })
      .forEach((item: any) => {
        dispatch.captcha.trackTouchMove(item);
      });
  }, []);

  useEffect(() => {
    dispatch.captcha.init();

    window.addEventListener("focus", handleWindowFocus);
    window.addEventListener("blur", handleWindowBlur);
    window.addEventListener("click", handleClick);
    window.addEventListener("mouseup", handleMouseUp);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchend", handleTouchEnd);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("deviceorientation", handleDevice);

    return () => {
      window.removeEventListener("focus", handleWindowFocus);
      window.removeEventListener("blur", handleWindowBlur);
      window.removeEventListener("click", handleClick);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("deviceorientation", handleDevice);
    };
  }, []);

  return null;
}
export default React.memo(CollectData);
